import { Modal } from '../../../components';
import TransactionLabelField from '../../../components/transaction/TransactionLabelField';
import { PaymentReportItem } from '../../../types/interfaces/paymentReport.interface';
import { centsToDollars } from '../../../services/account.service';
import {
  BREEDER_PAYMENTS_CONSTANTS,
  BUTTON_CONSTANTS,
  LABEL_CONSTANTS,
  MARKETPLACE_CONSTANTS,
  MARKETPLACE_MY_ORDERS_LABELS,
  TABLE_HEADER_CONSTANTS,
} from '../../../constants/common';
import './paymentReportDetailsModal.scss';

export type PaymentReportDetailsModalProps = {
  isOpen: boolean;
  width?: number;
  onClose: () => void;
  paymentDetail: PaymentReportItem | null;
};

const PaymentReportDetailsModal = ({ isOpen, width = 600, onClose, paymentDetail }: PaymentReportDetailsModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={width} ignoreBackdrop>
      <div className="payment-report-details-modal">
        <div className="payment-report-details card inventory-action">
          <h2>{BREEDER_PAYMENTS_CONSTANTS.PAYMENT_DETAILS}</h2>
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.ORDER_ID}:`}
            value={<label>{paymentDetail?.transactionId ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${MARKETPLACE_MY_ORDERS_LABELS.PRODUCT}:`}
            value={<label>{paymentDetail?.animalName ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.BUYER}:`}
            value={<label>{paymentDetail?.buyerName ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${LABEL_CONSTANTS.BUYER_EMAIL}:`}
            value={<label>{paymentDetail?.buyerEmail ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${LABEL_CONSTANTS.BUYER_PHONE_NUMBER}:`}
            value={<label>{paymentDetail?.buyerPhone ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.CATEGORY}:`}
            value={<label>{paymentDetail?.category ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${LABEL_CONSTANTS.UNITS}:`}
            value={<label>{paymentDetail?.units ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
          />
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.SALE_DATE}:`}
            value={
              <label>
                {paymentDetail?.saleDate
                  ? new Date(paymentDetail.saleDate).toLocaleDateString()
                  : MARKETPLACE_CONSTANTS.EMPTY_VALUE}
              </label>
            }
          />
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.GROSS_AMOUNT}:`}
            value={<label>${centsToDollars(paymentDetail?.grossAmountCents ?? 0)}</label>}
          />
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.NET_AMOUNT}:`}
            value={<label>${centsToDollars(paymentDetail?.netAmountCents ?? 0)}</label>}
          />
          <TransactionLabelField
            label={`${TABLE_HEADER_CONSTANTS.COMMISSION}:`}
            value={
              <label>
                ${centsToDollars(paymentDetail?.commissionCents ?? 0)} ({paymentDetail?.commissionRate ?? 0}%)
              </label>
            }
          />
        </div>
        <div className="flex-right">
          <button className="button medium green close-button" onClick={() => onClose()}>
            {BUTTON_CONSTANTS.CLOSE}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentReportDetailsModal;
